import ApiService from './api.service'
import { Error } from './responses/Error';
import moment from 'moment';

const StatsPobraniaService = {

    /**
     * Get total stats pobrania for Current User
     *
     * @returns total
     * @throws Error
     **/
    getTotal: async function(forceRefresh :boolean = false) {
        try {
            let attr = (forceRefresh) ? '?forceRefresh=true' : '';
            const response = await ApiService.get('/api/stats-pobrania/aggregated-total' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }

    },

    /**
     * Get aggregated stats pobrania for Current User or Product
     *
     * @returns list
     * @throws Error
     **/
    getAggregatedBetweenDates: async function(page: number = 1, recordsPerPage: number = 10, dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false, forceRefresh: boolean = false, productId :number = 0) {
        try {
            let attr = (productId) ? '/'+productId : '';
            attr += '?date_from='+dateFrom+'&date_to='+dateTo+'&page=' + page + '&recordsPerPage=' + recordsPerPage;
            if (lastYear) attr += '&year=last';
            if (forceRefresh) attr += '&forceRefresh=true';

            const response = await ApiService.get('/api/stats-pobrania/aggregated' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },



    /**
     * Get aggregated stats pobrania sum between dates for Current User or Product
     *
     * @returns list
     * @throws Error
     **/
    getAggregatedSumBetweenDates: async function(productId :number|null = null, dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false, forceRefresh: boolean = false) {
        try {
            let product = (productId) ? '/'+productId : '';
            let attr = '?date_from='+dateFrom+'&date_to='+dateTo;
            if (lastYear) attr += '&year=last';
            if (forceRefresh) attr += '&forceRefresh=true';

            const response = await ApiService.get('/api/stats-pobrania/aggregated-sum-between-dates' + product + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get detailed stats pobrania sum between dates for Current User or Product
     *
     * @returns list
     * @throws Error
     **/
    getDetailedListBetweenDates: async function(productId :number|null = null, dateFrom :string, dateTo :string = moment().format('YYYY-MM-DD'), lastYear :boolean= false, forceRefresh: boolean = false) {
        try {
            let product = (productId) ? '/'+productId : '';
            let attr = '?date_from='+dateFrom+'&date_to='+dateTo;
            if (lastYear) attr += '&year=last';
            if (forceRefresh) attr += '&forceRefresh=true';

            const response = await ApiService.get('/api/stats-pobrania/detailed' + product + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    }

}

export default StatsPobraniaService

export { StatsPobraniaService }
